import api from "../services/api";
import { useAuth } from "../context/AuthContext";

type SendWhatsAppButtonProps = {
  clientId: string;
};

export default function SendWhatsAppButton({ clientId }: SendWhatsAppButtonProps) {
  const { token } = useAuth();

  const handleSend = async () => {
    try {
      await api.post(`/clients/${clientId}/send-whatsapp`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert("WhatsApp message sent ✅");
    } catch {
      alert("Failed to send WhatsApp message");
    }
  };

  return (
    <button onClick={handleSend} className="px-4 py-2 bg-green-600 text-white rounded">
      Send WhatsApp
    </button>
  );
}
